<div class="card">
  <h2>{{ 'legacyUsers.pastActivities' | translate }}</h2>
  <bo-event-list-filter [events]="pastEvents()"/>
</div>
